export const LANGUAGES = [
  { code: 'en', labelKey: 'language.english' },
  { code: 'si', labelKey: 'language.sinhala' },
  { code: 'ta', labelKey: 'language.tamil' },
];
